<h1 mat-dialog-title class="dialog-title-container">
  Assigned Users
</h1>
<button mat-icon-button class="close-icon" (click)="onClose()">
  <mat-icon>close</mat-icon>
</button>

<div mat-dialog-content class="custom-dialog-content">
  <div class="table-container um-table-wrap">
    <table mat-table [dataSource]="dataSource" class="mat-table um-table">

    <!-- Users Column -->
    <ng-container matColumnDef="users">
      <th class="left-sorted-header" mat-header-cell *matHeaderCellDef>User</th>
      <td class="left-sorted-header" mat-cell *matCellDef="let element">{{ element.users }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  </div>
</div>


